import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StoreKeys } from '../../hooks/useStore/state';
import { useStore } from '../../hooks/useStore/useStore';
import { ProviderType } from '../../models/ProviderDetails';
import { Constants } from '../Constants';
import { phoneOnly } from '../ConstantsStyles';
import { Rating } from '../SnackCard/Rating';
import {
  ProviderRatingText,
  ProviderRatingsText,
} from './DetailsPageHeader.styled';

type Props = {
  rating?: string;
  providerType?: ProviderType;
  surveyCount?: number;
  color?: string;
  hideNumber?: boolean;
};

export const ProviderDetailsRating = ({
  hideNumber,
  rating,
  providerType,
  surveyCount,
  color = '$core.color.brand.100',
}: Props) => {
  const isWidget = useStore(StoreKeys.IS_WIDGET);
  const mobileScreen = useMediaQuery<boolean>(phoneOnly) || isWidget;
  const { t } = useTranslation();
  const surveyRating = surveyCount ? ` (${surveyCount})` : '';

  const ratingWithCount = rating
    ? `${rating}${surveyRating}`
    : t(Constants.PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.NA);

  const ratingText = rating
    ? rating
    : t(Constants.PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.NA);

  const RatingsText = () => (
    <Flex
      css={{
        alignItems: 'center',
      }}
    >
      <Rating hideNumber rating={Number(rating)} size={Number(ratingSize)} />
      <ProviderRatingsText
        aria-hidden="true"
        className="text"
        color={color}
        data-auto-testid="provider-details-rating"
        data-testid="provider-details-rating"
        fontSize={ratingSize}
      >
        {providerType == ProviderType.PRACTITIONER ? ratingText : null}
      </ProviderRatingsText>
    </Flex>
  );
  const RatingText = () => (
    <Flex
      css={{
        alignItems: 'center',
      }}
    >
      <Rating hideNumber rating={Number(rating)} size={Number(ratingSize)} />
      <ProviderRatingText
        aria-hidden="true"
        className="text"
        color={color}
        data-auto-testid="provider-details-rating"
        data-testid="provider-details-rating"
        fontSize={ratingSize}
      >
        {providerType == ProviderType.PRACTITIONER ? ratingWithCount : null}
      </ProviderRatingText>
    </Flex>
  );

  const ratingSize = mobileScreen ? 'sm' : 'md';

  if (mobileScreen) {
    return (
      <Flex
        css={{
          flexWrap: 'nowrap',
        }}
        data-testid="provider-deatials-header-rating-container"
        direction="row"
        justify="flex-end"
      >
        {hideNumber ? <RatingText /> : <RatingsText />}
      </Flex>
    );
  }

  return <Flex>{hideNumber ? <RatingText /> : <RatingsText />}</Flex>;
};
